<template>
    <div class="hello">

   <!-- Header start -->
    <header class="header">
        <div class="header__container flex-space">
            <a href="/" >
                <h1>vim.is</h1>
            </a>
          
          
        </div>
    </header>
    <!-- Header end -->

	<div class="basic-1 cards-1">
	<div class="container">
		<div class="row">


        <div class="col-lg-12">
            <div class="above-heading">Exercise {{index}}/{{this.data.length}} </div>
            <h2 class="">{{data[index].title}}</h2>
        </div>
    
        <div class="col-lg-12">
        <div v-html="data[index].question">> {{data[index].question}}
            <br></div>
        <br>
        </div>
    
        <div id="parent" v-on:click="start()">
            <VueCodeEditor @init="editorInit" theme="monokai" width="100%" height="200px" id="editor" name="editor" v-on:input="onChange" v-model=answer ref="editor" :options="{
                fontSize: 18,
                highlightActiveLine: true,
                showLineNumbers: true,
                tabSize: 2,
            }" />>
        </div>
       
        <div class="col-lg-12">
            <!-- 
              <span class="btn-solid-reg popup-with-move-anim" href="#details-lightbox-1" v-on:click="back()">Last exercise</span>
              <span class="btn-solid-reg popup-with-move-anim" href="#details-lightbox-1" v-on:click="next()">Next exercise</span>
            -->

            <div class="hero-cta">
                <a href="#exercise" class="btn btn__primary" v-on:click="restart()">
                    RESTART
                </a>

                <a href="#exercise" class="btn btn__default" v-on:click="reset()">
                    RESET
                </a>
                <div style="margin-right:1rem;"></div>  
                <a href="../overview" class="btn btn__default">
                    OVERVIEW
                </a>
            </div>

            <br /><a href="../overview">Lesson Plan</a>


            <!-- {{this.answer}} -->
        </div>
    </div>

      </div>
  </div>

  </div>
</template>

<script>
import router from '../router'

window.ace.require = window.ace.acequire;
// import { Ace as AceEditor } from 'vue2-brace-editor';
import VueCodeEditor from 'vue2-code-editor';

export default {
    components: {
        VueCodeEditor
    },
    name: 'HelloWorld',
    metaInfo: {
        title: 'Vim Exercise - vim.is'
    },
    props: {
        msg: String
    },
    computed: {
        formattedElapsedTime() {
            const date = new Date(null);
            //date.setSeconds(this.elapsedTime / 1000);
            date.setMilliseconds(this.elapsedTime);
            const utc = date.toISOString();
            return utc.substr(utc.indexOf(".") - 2, 5) + 's';
        },
        id() {
            return this.$route.params.id;
        },
    },
    created: function() {

        var key = this.$cookie.get('key');
        if (key === null) 
            router.replace("/login");


        this.getData();

    },
    methods: {
        getId: function() {
            return this.$route.params.id;
        },
        start: function() {
            this.startTimer();
        },
        editorInit: function(editor) {
            require('brace/mode/html')
            require('brace/mode/python')
            require('brace/mode/less')
            require('brace/theme/chrome')
            require('brace/theme/dracula')
            require('brace/theme/monokai')
            editor.setOption('fontSize', '16pt')
            editor.setOption('vScrollBarAlwaysVisible', true)
            editor.setOption('theme', 'ace/theme/textmate')
            require('brace/keybinding/vim')
            editor.setKeyboardHandler('ace/keyboard/vim')

            //this.answer = this.placeholders[this.index];
        },
        editorRender: function(output) {
            require('brace/mode/html')
            require('brace/mode/python')
            require('brace/mode/less')
            require('brace/theme/chrome')
            require('brace/theme/chaos')
            require('brace/theme/monokai')
            output.setOption('fontSize', '16pt')
            output.setOption('vScrollBarAlwaysVisible', true)
            output.setOption('theme', 'ace/theme/textmate')
        },
        onChange: function() {
            this.correct();
        },
        correct: function() {
            //console.log(' answer   = ', this.answer, this.answer.length, typeof this.answer);
            //console.log(' solution = ', this.data[this.index].solution, this.index, this.data[this.index].solution.length, typeof this.data[this.index].solution);
            if (this.data[this.index].solution == this.answer) {
                //console.log(this.index);
                //console.log(this.data.length);
                
                var myid = this.getId();
                
                if (this.index >= this.data.length - 1) {
                  if (Number(myid) + 1 >= this.api.length) {
                    router.replace("/overview");
                    return;
                  }
                  console.log('next exercise');
                  this.index = 0;
                  this.score = 0;
                  var id = Number(myid) + 1;
                  this.id = id;
                  this.getData();
                  router.replace("/exercise/" + (id) );
                }
                this.oldIndex = 0;
                //console.log('correct');
                this.answer = '';
                this.score = this.score + 1;
                this.index = this.index + 1;
                //console.log('index is ', this.index);
                this.totalTime += this.elapsedTime;
                this.calculateAverageTime();
                this.resetTimer();
                this.startTimer();
                
                //this.answer = this.data[this.index].placeholder;

                setTimeout(() => {
                    this.answer = this.data[this.index].placeholder;
                }, 10)

            }
        },
        restart: function() {
            console.log('restart');
            this.index = 0 ;
            this.score = 0;
            this.answer = this.data[this.index].placeholder;
            this.totalTime = 1;
            this.resetTimer();
            this.calculateAverageTime();
        },
        reset: function() {
            console.log('reset');
            this.answer = this.data[this.index].placeholder;
            this.totalTime = 1;
            this.resetTimer();
            this.calculateAverageTime();
        },
         startTimer() {
            this.timer = setInterval(() => {
                this.elapsedTime += 101;
            }, 101);
        },
        stopTimer() {
            clearInterval(this.timer);
        },
        resetTimer() {
            this.elapsedTime = 1;
        },
        calculateAverageTime() {
            const date = new Date(null);
            //date.setSeconds(this.elapsedTime / 1001);
            date.setMilliseconds(this.totalTime / this.score);
            const utc = date.toISOString();
            this.averageTime = utc.substr(utc.indexOf(".") - 3, 5) + 's';
        },
        getData() {
            if (!this.api[this.id]) {
                router.replace("/overview");
                return;
            }
            fetch(this.api[this.id])
                .then(response => response.json())
                .then(data => (this.data = data))
                .then(response => {
                    this.answer = this.data[this.index].placeholder;
                    console.log('fetched data', response);
                });

        },
    },
    data: function() {
        return {
            elapsedTime: 1,
            totalTime: 1,
            averageTime: 1,
            timer: undefined,
            answer: "",
            score: 0,
            index: 0,
            data: [{},{}],
            title: '',
            exercise: [],
            api: [
                '../ex-001-hl.json',
                '../ex-002-hl2.json',
                '../ex-003-j.json',
                '../ex-004-jk.json',
                '../ex-005-hjkl.json',
                '../ex-006-x.json',
                '../ex-007-X.json',
                '../ex-008-xcount.json',
                '../ex-009-undo.json',
                '../ex-010-redo.json',
                '../ex-011-dollar.json',
                '../ex-012-zero.json',
                '../ex-013-caret.json',
                '../ex-014-w.json',
                '../ex-015-b.json',
                '../ex-016-e.json',
                '../ex-017-W.json',
                '../ex-018-grid.json',
                '../ex-019-G.json',
                '../ex-020-i.json',
                '../ex-021-a.json',
                '../ex-022-Ins.json',
                '../ex-023-A.json',
                '../ex-024-o.json',
                '../ex-025-O.json',
                '../ex-026-counti.json',
                '../ex-027-dw.json',
                '../ex-028-db.json',
                '../ex-029-d3w.json',
                '../ex-030-daw.json',
                '../ex-031-dd.json',
                '../ex-032-ddn.json',
                '../ex-033-dj.json',
                '../ex-034-dgg.json',
                '../ex-035-D.json',
                '../ex-036-d0.json',
                '../ex-037-r.json',
                '../ex-038-R.json',
                '../ex-039-s.json',
                '../ex-040-S.json',
                '../ex-041-cw.json',
                '../ex-042-ce.json',
                '../ex-043-c3w.json',
                '../ex-044-C.json',
                '../ex-045-cc.json',
                '../ex-046-dotx.json',
                '../ex-047-dotdw.json',
                '../ex-048-dotcw.json',
                '../ex-049-dotA.json',
                '../ex-050-doto.json',
                '../ex-051-dot3.json',
                '../ex-052-undoins.json',
                '../ex-053-yyp.json',
                '../ex-054-yyP.json',
                '../ex-055-ddp.json',
                '../ex-056-ddkP.json',
                '../ex-057-xp.json',
                '../ex-058-ywP.json',
                '../ex-059-3yy.json',
                '../ex-060-3p.json',
                '../ex-061-reg.json',
                '../ex-062-reg0.json',
                '../ex-063-f.json',
                '../ex-064-F.json',
                '../ex-065-t.json',
                '../ex-066-T.json',
                '../ex-067-ct.json',
                '../ex-068-df.json',
                '../ex-069-semi.json',
                '../ex-070-comma.json',
                '../ex-071-ciw.json',
                '../ex-072-ciq.json',
                '../ex-073-diq.json',
                '../ex-074-daq.json',
                '../ex-075-ciq1.json',
                '../ex-076-cip1.json',
                '../ex-077-dip1.json',
                '../ex-078-dap1.json',
                '../ex-079-cib.json',
                '../ex-080-dib.json',
                '../ex-081-ciB.json',
                '../ex-082-diB.json',
                '../ex-083-dap.json',
                '../ex-084-cip.json',
                '../ex-085-v.json',
                '../ex-086-viwp.json',
                '../ex-087-Vd.json',
                '../ex-088-Vyp.json',
                '../ex-089-vcase.json',
                '../ex-090-Vind.json',
                '../ex-091-blockd.json',
                '../ex-092-blockr.json',
                '../ex-093-NG.json',
                '../ex-094-colonN.json',
                '../ex-095-para.json',
                '../ex-096-pct.json',
                '../ex-097-slash.json',
                '../ex-098-N.json',
                '../ex-099-qmark.json',
                '../ex-100-star.json',
                '../ex-101-star2.json',
                '../ex-102-mark.json',
                '../ex-103-mark2.json',
                '../ex-104-s1.json',
                '../ex-105-sg.json',
                '../ex-106-rename.json',
                '../ex-107-gi.json',
                '../ex-108-range.json',
                '../ex-109-pre.json',
                '../ex-110-trim.json',
                '../ex-111-digits.json',
                '../ex-112-groups.json',
                '../ex-113-sort.json',
                '../ex-114-sortr.json',
                '../ex-115-sortu.json',
                '../ex-116-tilde.json',
                '../ex-117-g_iw.json',
                '../ex-118-gUiw.json',
                '../ex-119-guiw.json',
                '../ex-120-gUend.json',
                '../ex-121-g__.json',
                '../ex-122-inc.json',
                '../ex-123-dec.json',
                '../ex-124-incdot.json',
                '../ex-125-J.json',
                '../ex-126-indent.json',
                '../ex-127-dedent.json',
                '../ex-128-indentn.json',
                '../ex-129-boss1.json',
                '../ex-130-boss2.json',
                '../ex-131-boss3.json',
                '../ex-132-boss4.json',
                '../ex-133-boss5.json',
                '../ex-134-boss6.json',
                '../ex-135-boss7.json',
                '../vim-cursor-end-of-line.json',
                '../vim-jump-words.json',
                '../vim-insert.json',
                '../vim-insert-start.json',
                '../vim-append.json',
                '../vim-insert-below.json',
                '../vim-insert-above.json',
                '../vim-delete-bulk.json',
                '../vim-delete-until-end-of-line.json',
                '../vim-ce.json',
                '../vim-replace-mode.json',
                '../vim-copy-line.json',
                '../vim-copypaste.json',
                '../vim-jump-char.json',
                '../vim-search-replace.json',
                '../vim-repeat.json',
                '../vim-upper-lower-text.json',
                '../vim-increase-number.json'
            ]
        }
    }
}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import '../assets/hero/css2.css';
@import '../assets/hero/normalize.css';
@import '../assets/hero/style.css';
@import '../assets/hero/responsive.css';

.btn:hover {
}

.above-heading {
    font-size: 12px;
    font-style: bold;
}

.hero-cta {
    color: white;
}

h2 {
    font-size: 4.2rem;
    line-height: 1.1;
    margin-bottom: 25px;
}
.above-heading {
    color: #5f4dee;
    font: 0.70.75rem/0.075rem "Open Sans", sans-serif;
    text-align: center;
}

h4 {
    margin: 41px 0 0;
}

ul {
    list-style-type: none;
    padding: 1;
}

li {
    display: inline-block;
    margin: 1 10px;
}


#parent {
    width: 101%;
    height: 226px;
    display: block;
    position: relative;
}

#editor {
    position: absolute;
    /* Added */
    top: 1;
    right: 1;
    bottom: 1;
    left: 1;
    margin: 1 auto;
    border-radius: 9px;
}

.btn-solid-reg {
    cursor: pointer;
}

.score {
    font: 701 1rem/1.625rem "Open Sans", sans-serif;
    letter-spacing: 1.1px;
}

.divider {
    height: 2px;
    margin-top: 2.75rem;
    margin-bottom: 3rem;
    border: none;
    background-color: #ccd4df;
}

.box {
    display: block;
    max-width: 20rem;
    margin-right: auto;
    margin-bottom: 4rem;
    margin-left: auto;
    border: 2px solid #ccd3df;
    border-radius: 1.375rem;
    ;
    display: inline-block;
    margin: 11px;
    padding: 16px;
}
</style>
